/* -------------------------------------------------------------------
   KV: make the quick-shop modal actually work.

   Edge builds the quick view by fetching the product section and
   dropping it in with innerHTML. Scripts inserted that way NEVER RUN —
   that is a browser rule, not a theme bug. So <product-info>,
   <media-gallery> and friends arrive in the DOM as undefined custom
   elements: inert markup that looks right and does nothing.

   What that broke, in order of how much it cost:

   1. Picking a size in quick shop did not change the variant at all.
      The hidden id input kept the FIRST variant, so choosing L and
      hitting Add to cart added XS. Silently. This is the reason this
      file exists.
   2. Add to cart never went to its Sold out state.
   3. Because of (2), Klaviyo had no sold-out button to replace, so
      back-in-stock never appeared in quick shop.

   Fix: re-execute the injected <script src> tags once each. Defining
   the class upgrades the elements already sitting in the DOM, so the
   quick view comes alive and every later quick view works natively.

   Back-in-stock is handled separately below — see that comment.
   ------------------------------------------------------------------- */
(function () {
  "use strict";
  if (window.__kvQuickViewBoot) return;
  window.__kvQuickViewBoot = true;

  var HOST_ID = "product-quick-view__product-content";
  var BIS_CLASS = "kv-quickview-bis";
  var BIS_LABEL = "Email Me When Available";

  /* Every script already on the page has run normally. Only ones that
     arrive later, inside injected markup, need help. */
  var seen = Object.create(null);
  Array.prototype.forEach.call(document.querySelectorAll("script[src]"), function (s) {
    if (s.src) seen[s.src] = true;
  });

  function runInjectedScripts(root, onEach) {
    Array.prototype.forEach.call(root.querySelectorAll("script[src]"), function (old) {
      var src = old.src; // resolved absolute by the browser
      if (!src || seen[src]) return;
      seen[src] = true;
      var s = document.createElement("script");
      s.src = src;
      s.defer = true;
      s.setAttribute("data-kv-quickview-boot", "");
      if (onEach) {
        s.addEventListener("load", onEach);
        s.addEventListener("error", onEach);
      }
      document.head.appendChild(s);
    });
  }

  /* -----------------------------------------------------------------
     Back-in-stock inside quick shop.

     Klaviyo's onsite script binds once, at page load, and only where it
     has a product context. A collection page has none, and Klaviyo will
     not re-scan afterwards — re-calling klaviyo.enable(), seeding
     window.meta.product and planting a bare .klaviyo-bis-trigger anchor
     were all tried and all ignored. So there is no way to open Klaviyo's
     modal from here.

     Instead: when the chosen size is sold out, offer a button that goes
     to the product page with that exact variant preselected, where
     Klaviyo's real button is waiting. One extra click, and it always
     works, which beats a button that only sometimes does.
     ----------------------------------------------------------------- */
  function syncBackInStock(root) {
    var submit = root.querySelector('[name="add"]');
    var info = root.querySelector("product-info[data-url]");
    var existing = root.querySelector("." + BIS_CLASS);
    var soldOut =
      submit && (submit.disabled || submit.getAttribute("aria-disabled") === "true");

    if (!soldOut || !info) {
      if (existing) existing.remove();
      return;
    }

    var idInput = root.querySelector('[name="id"]');
    var href = info.getAttribute("data-url");
    if (idInput && idInput.value) href += "?variant=" + idInput.value;

    var link = existing;
    if (!link) {
      link = document.createElement("a");
      link.className = "btn btn-primary kv-bis-trigger " + BIS_CLASS;
      link.textContent = BIS_LABEL;
      submit.parentNode.insertBefore(link, submit.nextSibling);
    }
    link.setAttribute("href", href);
  }

  function boot() {
    var host = document.getElementById(HOST_ID);
    if (!host) return;

    var sync = function () { syncBackInStock(host); };

    var observer = new MutationObserver(function () {
      if (!host.children.length) return; // closed and emptied
      runInjectedScripts(host, sync);
      sync();
    });

    /* childList only. Watching attributes too would loop, because
       setting href on our own button is an attribute change. */
    observer.observe(host, { childList: true, subtree: true });

    if (host.children.length) {
      runInjectedScripts(host, sync);
      sync();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
